const TEMPLATES_STORAGE_KEY = 'camping_communication_templates';

export function loadConfirmationTemplateFromStorage(): { subject?: string; content: string } | null {
  try {
    const stored = localStorage.getItem(TEMPLATES_STORAGE_KEY);
    if (!stored) return null;
    const templates = JSON.parse(stored) as Array<{
      id?: string;
      trigger?: string;
      name?: string;
      subject?: string;
      content?: string;
    }>;
    const confirmationTemplate = templates.find(
      (tpl) =>
        tpl.id === '1' ||
        tpl.trigger === 'onConfirmation' ||
        (tpl.name && tpl.name.toLowerCase().includes('confirmation'))
    );
    if (confirmationTemplate?.content) {
      return {
        subject: confirmationTemplate.subject || '',
        content: confirmationTemplate.content,
      };
    }
  } catch (error) {
    console.error('Error loading confirmation template:', error);
  }
  return null;
}
